import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { AvatarImg, RotatePositionType, AvatarSmileType } from '@shared/avatar-with-message/avatar-with-message.types';

@Component({
    selector: 'companyid-avatar-with-message',
    templateUrl: './avatar-with-message.component.html',
    styleUrl: './avatar-with-message.component.scss',
    imports: [JoinClassNamesPipe, NgOptimizedImage, AssetPipe],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarWithMessageComponent {
    public classNames = input.required<string>();
    public position = input.required<RotatePositionType>();
    public title = input.required<string>();
    public avatarImg = input.required<AvatarImg>();
    public subtitle = input.required<string>();
    public smile = input<AvatarSmileType>();
}
